import Vue from 'vue';
import Cart from 'components/cart/Cart.vue';

new Vue({
  el: '#Cart',
  render: function (createElement) {
    return createElement(Cart, {
      props: { }
    })
  }
});
